export const DOMAIN = 'https://oldold.semnexus.com/';
export const S3_SEMNEXUS = 'https://semnexus-web.s3.us-east-1.amazonaws.com';